import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {defaultTemplate} from 'core/hoc';

class SearchFilterTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    onChange = event => {
        const { queryUtility, propertyName } = this.props;

        queryUtility.filter[propertyName] = event.target.value;
    };

    onSearch = () => {
        const { queryUtility, propertyName } = this.props;

        queryUtility.filter[propertyName] = _.trim(queryUtility.filter[propertyName]);

        if (!queryUtility.filter[propertyName]) {
            queryUtility.filter[propertyName] = null;
        }

        queryUtility.fetch();
    };

    onKeyPress = event => {
        if (event.key === 'Enter') {
            this.onSearch();
        }
    };

    onInlineReset = () => {
        const { queryUtility, propertyName } = this.props;

        queryUtility.filter[propertyName] = null;

        queryUtility.fetch();
    };

    render() {
        const {
            queryUtility,
            propertyName = 'search',
            className,
            t,
            placeholder = 'Search',
            clearVisible
        } = this.props;

        return <React.Fragment>
            <div className='iputgroup'>
                <div className='inputgroup--main'>
                    <input className={className} type="text" placeholder={placeholder}
                       value={queryUtility.filter[propertyName] || ""}
                       onChange={this.onChange}
                       onKeyPress={this.onKeyPress}/>
                    {queryUtility.filter[propertyName] && queryUtility.filter[propertyName] !== '' &&
                    <span className='filter__btn--clear' onClick={this.onInlineReset}>
                        <i className='u-icon u-icon--xsml u-icon--close--light'/>
                    </span>
                }
                </div>
                {clearVisible &&
                <div className="inputgroup--aside inputgroup--aside--secondary u-display--none">
                    <button className='btn btn--base btn--ghost' onClick={() => queryUtility.resetFilter()}>
                        {t('GRID.FILTER.CLEAR_BUTTON')}
                    </button>
                </div>}
                <div className="inputgroup--aside">
                    <button className='btn btn--base btn--primary spc--right--sml' onClick={this.onSearch}>
                        <span className='align--v--bottom'>
                            {t('GRID.FILTER.SEARCH_BUTTON')}
                        </span>
                    </button>
                    
                </div>
                
            </div>
            
        </React.Fragment>;
    }
}

SearchFilterTemplate.propTypes = {
    queryUtility: PropTypes.object,
    propertyName: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    clearVisible: PropTypes.bool,
    t: PropTypes.func
};

SearchFilterTemplate.defaultProps = {
    propertyName: 'search',
    placeholder: 'Search',
    clearVisible: false
};

export default defaultTemplate(SearchFilterTemplate);
